import React from 'react';
import CategoryChips from './CategoryChips';
import CategoryDropdown from './CategoryDropdown';
import {
  CATEGORY_PICKER_VARIANT,
  type CategoryPickerVariant,
} from './categoryPickerConfig';
import type { CategoryPickerBodyProps } from './categoryPickerTypes';

export interface CategoryPickerProps extends CategoryPickerBodyProps {
  // Overrides the configured variant. Only for Storybook and tests, so both
  // variants can be rendered side by side; production call sites omit it and
  // follow CATEGORY_PICKER_VARIANT.
  variant?: CategoryPickerVariant;
}

// ENG-2551: the single swap point between the two folded-state category
// pickers. Both background surfaces render this rather than a concrete variant,
// so changing CATEGORY_PICKER_VARIANT switches them together.
const CategoryPicker = ({ variant, ...bodyProps }: CategoryPickerProps) => {
  const activeVariant = variant ?? CATEGORY_PICKER_VARIANT;

  if (activeVariant === 'dropdown') {
    return <CategoryDropdown {...bodyProps} />;
  }

  return <CategoryChips {...bodyProps} />;
};

export default CategoryPicker;
